import CategoryPlate from './category-plate';

export default CategoryPlate;